import { PremiumAccessCreate } from "./premiumAccessCreate";
import { PremiumAccessEdit } from "./premiumAccessEdit";
import { PremiumAccessList } from "./premiumAccessList";

export default {
	create: PremiumAccessCreate,
	edit: PremiumAccessEdit,
	list: PremiumAccessList,
};